import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs';
import { SettlementsService } from 'src/app/services/settlements.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-contract-index',
  template: `
    <div class="d-flex mt-0 mt-md-4">
      <div class="flex-fill">
        <h1 class="mt-2 mt-md-0">Clientes</h1>
      </div>
    </div>
    <div class="d-flex mt-4">
      <div class="me-3 d-none d-md-block">
        <ul #subnav app-nav-settlements [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
      </div>
    
      <div class="flex-fill ms-auto">
        <div class="d-flex mb-3">
          <div class="flex-fill ms-2">
            <h2 class="mt-2 mt-md-0 mb-0">Contratos</h2>
          </div>
        </div>
        <div class="d-flex">
          <div class="flex-fill ms-3 me-3">
            <div class="input-group mb-3">
              <input class="form-control border-secondary border-end-0 rounded-start-3 bg-transparent" placeholder="Buscar..." [formControl]="search">
              <div class="input-group-append border border-secondary border-start-0 rounded-end-3 bg-transparent">
                <fa-icon [icon]="icons.faSearch" *ngIf="!search.value" class="input-group-text bg-transparent border-0 mt-1"></fa-icon>
                <fa-icon [icon]="icons.faTimes" *ngIf="search.value" (click)="clearSearch()" class="input-group-text bg-transparent border-0 mt-1"></fa-icon>
              </div>
            </div>
          </div>
          
        </div>
        <div class="list-group rounded-4 rounded-md-5 mt-4">
          <div class="list-group-item table-responsive py-4">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-left-3 py-2 ps-3">#</th>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2">Documento</th>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2 d-none d-md-table-cell">Condominio</th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Depto.</th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Contrato</th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Fecha firma</th>                  
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-right-3 py-2"></th>
                </tr>
              </thead>
              <tbody>
                <tr app-tr-contract
                  [contract]="contract"
                  *ngFor="let contract of contracts | paginate: { itemsPerPage: payload.per_page, currentPage: p, totalItems: meta.total_entries }"
                ></tr>
              </tbody>
            </table>
            <div class="text-center py-5" *ngIf="contracts.length==0&&loading">
              <fa-icon [icon]="icons.faCircleNotch" size="2x" animation="spin" class="text-secondary"></fa-icon>
              <p class="text-muted">Cargando...</p>
            </div>
            <div class="text-center py-5" *ngIf="contracts.length==0&&!loading" >
              <img src="/assets/images/empty-state.png" width="240px">
              <p class="text-muted">No se encontraron registros</p>
            </div>
          </div>
          <div class="list-group-item text-center pt-3">
            <pagination-controls
              (pageChange)="p = $event"
              (pageChange)="pageChanged($event)"
              previousLabel="Prev."
              nextLabel="Sig."
              screenReaderPaginationLabel="Pagination"
              screenReaderPageLabel="page"                  
            ></pagination-controls>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class ContractIndexComponent {
  contracts: any[] = [];
  contractTypes: any[] = [];
  meta: any = {};
  loading: boolean = false;

  currentView: string | null = 'contratos';

  payload: any = {
    page: 1,
    per_page: 10,
  };

  p: number = 1;
  search: FormControl = new FormControl();

  constructor(
    private store: SettlementsService,
    private toastr: ToastrService,
    public icons: IconsService
  ) { }

  ngOnInit(): void {
    this.loadContracts(this.payload);
    this.loadContractTypes();

    this.search.valueChanges.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      switchMap((term: string) => this.store.getContracts({
        name: term,
        page: 1,
        per_page: this.payload.per_page,
      }))).subscribe((results: any) => {
        this.contracts = results.data;
        this.meta = results.meta;
      });
  }

  pageChanged(event: any) {
    console.log('page changed => ', event);
  }

  clearSearch() {
    delete this.payload.name;
    this.search.setValue(null);
    this.loadContracts(this.payload);
  }

  loadContracts(payload: any) {
    console.log('load contracts');
    this.store.getContracts(payload).subscribe({
      next: (data: any) => {
        console.log('contracts => ', data);
        this.contracts = data.data;
        this.meta = data.meta;
        this.toastr.success('Contratos cargados correctamente');
      },
      error: (error: any) => {
        console.log('contracts error => ', error);
        this.toastr.error('Error al cargar los contratos');
      },
    });
  }

  loadContractTypes() {
    this.store.getContractTypes({}).subscribe({
      next: (data: any) => {},
      error: (error: any) => {},
    });
  }


}
